export const STATUSES = ["draft", "unclaimed", "contacted", "claimed", "verified"];

export const STATUS_STYLES = {
  draft: { text: "#475569", bg: "#F1F5F9", border: "#CBD5E1", label: "Draft" },
  unclaimed: { text: "#B45309", bg: "#FEF3C7", border: "#FDE68A", label: "Unclaimed" },
  contacted: { text: "#1D4ED8", bg: "#DBEAFE", border: "#BFDBFE", label: "Contacted" },
  claimed: { text: "#4338CA", bg: "#EEF2FF", border: "#C7D2FE", label: "Claimed" },
  verified: { text: "#047857", bg: "#D1FAE5", border: "#6EE7B7", label: "Verified" },
};

export const NOTE_TYPES = [
  { value: "call_log", label: "Phone Call" },
  { value: "email", label: "Email Sent" },
  { value: "verification", label: "Verification" },
  { value: "general", label: "Internal Note" },
];

export const DOC_TYPES = [
  { value: "business_registration", label: "Business Registration" },
  { value: "license", label: "Professional License" },
  { value: "insurance", label: "Insurance Certificate" },
  { value: "other", label: "Other" },
];
